import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router'
import '../styling/containerStyles.css'
import VerifyNumber from './verifyNumber'
import VerifyOtp from './verifyOtp'
import CustomerDetails from './customerDetails'
import TransactionDetails from './transactionDetails'
import BankDetails from './bankDetails'
import Success from './successTransaction'
import Footer from '../components/footer'
import CircularProgress from '@material-ui/core/CircularProgress'
import Payouts from '../container/paytmPayout'
import PreviousBankDetails from '../container/previousBankDetails';
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import ErrorMessage from './errorMessage';

interface MainContractorProps{
  questionType:string;
}

export const MainContractor: React.FC<MainContractorProps> = (props: MainContractorProps) =>{

    const [phoneNo, setPhoneNo] = useState('')
    const [codeScanStatus, setCodeScanStatus] = useState(true)
    const [codeScanStatusCode, setCodeScanStatusCode] = useState('')
    const [isVerified, setIsVerified] = useState(false) 
    const [isOtpVerified, setIsOtpVerified] = useState(false)
    const [isNewUser, setIsNewUser] = useState(true) 
    const [newUser, setNewUser] = useState(true) 
    const [isProceeded, setIsProceeded] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const [amount, setAmount] = useState('')
    const [bonusAmount, setBonusAmount] = useState('')
    const [paymentType, setPaymentType] = useState('')
    const [paymentStatus, setPaymentStatus] = useState('')
    const [accNo, setAccNo] = useState('')
    const [ifsc, setIfsc] = useState('')
    const [bankDetailsSet, setBankDetailsSet] = useState(false)
    const [membershipID, setMembershipID] = useState('')
    const [redeemable, setRedeemable] = useState(false)
    const [paymentMessage, setPaymentMessage] = useState('')
    const [msgPh, setMsgPh] = useState('')
    const [bankMsg, setBankMsg] = useState('')
    const [transactions, setTransactions] = useState('')
    const [conversions, setConversions] = useState(['', '', ''])
    const [confirmedPayStatus, setConfirmedPayStatus] = useState(false)
    const [orderID, setOrderID] = useState('')
    const [razorID, setRazorID] = useState('')
    const [canRedeem, setCanRedeem] = useState(true)
    const [couponValid, setInvalidCoupon] = useState(false)
    const [otpMessage, setOtpMessage] = useState('')
    const [failUnbind, setFailUnbind] = useState('')
    const [transactionLoading, setTransactionLoading] = useState(false)
    const [countCheck, setCount] = useState(true)
    const [previousBankDetails, setPreviousBankDetails] = useState('')
    const [previousBankDetailsFlag, setPreviousBankDetailsFlag] = useState(false)
    const [prevBankType, setPreviousBankType] = useState(false)
    const [prevBankUUID, setPreviousBankUUID] = useState(['', ''])
    const [loadingRedeem, setLoadingRedeem] = useState(false)
    const [bonusPoint, setBonusPoint] = useState(['', '', ''])

    const HOST = process.env.REACT_APP_HOST; 
    const API = process.env.REACT_APP_API;

    const path = window.location.pathname;
    const pathParams = path.split('/')

    const refresh_error_msg = 'Token is invalid or expired';
    let count = 0; 
    
    let hostName = window.location.hostname.split('.')[0]
    let userType = ''

    // When need to run in local
    if(hostName === 'localhost'){
      hostName = 'hccinstantrewards'
    }

    if(hostName === 'saathirewards'){
      userType = 'FCC'
    }
    else if(hostName === 'hccinstantrewards'){
      userType = 'CWC'
    }
    else if(hostName === 'paytm-instant-rewards'){
      userType = 'CWC'
    }

    interface ParamTypes {
      couponId: string,
    }

    const couponCode = useParams<ParamTypes>().couponId
    
    const axios = require('axios').default;

    const resetAll = (couponUnbind: boolean) => {
        
        setIsOtpVerified(false)
        setIsVerified(false)
        setIsProceeded(false)
        setIsSuccess(false)
        setIsNewUser(true)
    }

    const resetWhileLogoutAll = (couponUnbind: boolean) => {
      setIsOtpVerified(true)
      setIsProceeded(false)
  }

    useEffect(() => {
      checkCode();
      if(localStorage.getItem("IS_LOGIN") === "yes") {
        resetWhileLogoutAll(true);
      }
    }, [])

    const checkCode = async() => {
      setLoading(true)
      return axios
      .post(
        `${HOST}${API}check-coupon-code/`,
        {
          code: couponCode,
          user: userType
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        const data = res.data.data
        if(data.resultCode === 0){
          setAmount(data.codePoint)
          if(localStorage.getItem("IS_LOGIN") === "yes") {
            handleToUpdateOTP("");
          }
        }
        else{
          setCodeScanStatusCode(data.resultCode)
          setInvalidCoupon(true)
          setCodeScanStatus(false)
          setIsOtpVerified(false)
          setIsVerified(false)
        }
        setLoading(false)
        return data;
      })
      .catch((err: any) => {
        const amtInvalid = err.response.data;
        if(amtInvalid.amount_invalid === true) {
          handleToUpdateStatus('AMOUNTINVALID', amtInvalid.message, '-', '-')
        }
        if(amtInvalid.user_blocked === true) {
          handleToUpdateStatus('BLOCKUSER', amtInvalid.message, '-', '-')
        }
          setCodeScanStatusCode(amtInvalid.resultCode)
          setCodeScanStatus(false)
          setIsOtpVerified(false)
          setIsVerified(false)
          setLoading(false)
          return err;
      });
    }

    const getOtp = async (arg: any) => {
      setLoading(true)
      return axios
      .post(
        `${HOST}${API}login/get-otp/`,
        {
          phone_number: arg, 
          app_name: 'paytm', 
          paytm_user_type: userType
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        setLoading(false)
        return res;
      })
      .catch((err: any) => {
          setLoading(false)
          return err;
      });
    }

    const handleToUpdateNumber= async (arg: any) => {
      if(codeScanStatus === true){
        setPhoneNo(arg)
          try {
            const checkCodeResponse = await checkCode()                 
            if(checkCodeResponse.resultCode === 0){
              setAmount(checkCodeResponse.codePoint)
              if(localStorage.getItem("IS_LOGIN") === "yes") {
                // resetWhileLogoutAll(true);
                // redemption();
                handleToUpdateOTP("");
              }
              const fetchResponse = await getOtp(arg);
              if(fetchResponse.status === 200){
                localStorage.setItem('phone_number', arg)
                setIsVerified(true)
              }
              else{
                setMsgPh('Something went wrong')
              }
            }
            else{
              setCodeScanStatusCode(checkCodeResponse.resultCode)
              setInvalidCoupon(true)
              setCodeScanStatus(false)
              setIsOtpVerified(false)
              setIsVerified(false)
            }
            
          } catch (e) {
            setMsgPh('Something went wrong')
          }
        }       
    }
    
    const getTokenPair = (phoneNumber: any, otp: any) => {
        return axios
          .post(
            `${HOST}${API}login/token-access/`, 
            {
              phone_number: phoneNumber,
              otp: otp,
              app_name: 'paytm'
            },
            {
              headers: {
                'Content-Type': 'application/json',
              }
            }
          )
          .then((res: any) => {
            localStorage.setItem('IS_LOGIN', "yes")
            return res;
          })
          .catch((err: any) => {
            return err;
          });
    };

    const redemption = async() =>{ 
      setLoading(true)
      setLoadingRedeem(true)
      return axios
          .post(
            `${HOST}${API}check-redeemability/`, 
            {
              phone_number: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo,
              division: "",
              product: pathParams[1]
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token')
              }
            }
          )
          .then((res: any) => {
            setLoading(false)
            setLoadingRedeem(false)
            if(res.data.data.endusercategory_c){
              localStorage.setItem("isEndUserCategory", res.data.data.endusercategory_c);
            }
            return res;
          })
          .catch((err: any) => {
            const memberValidation = err.response.data;
            if(memberValidation.user_can_order === true) {
              handleToUpdateStatus('MEMBERINVALID', memberValidation.message, '-', '-');
            }
            setLoading(false)
            setLoadingRedeem(false)
            return err;
          });
    }

    const refresh_access_token = async (res: any) => {
        return axios
          .post(
            `${HOST}${API}login/token-refresh/`, 
            {
              refresh: localStorage.getItem('x-refresh-token')
            },
            {
              headers: {
                'Content-Type': 'application/json',       
              }
            }
          )
          .then((res: any) => {
              if(res.status === 200){
                localStorage.setItem('x-access-token', 'Token ' + res.data['access'])
              }
              else{
                setMsgPh('something went wrong')
                setIsVerified(false)
              }
            })
          .catch((err: any) => {
            setMsgPh('something went wrong')
            setIsVerified(false)
          });
    }

    const handleToUpdateOTP = async (arg: any) => {
        if(arg === 'GoBack'){
            setIsVerified(false)
        }
        else {
          if(!localStorage.getItem("IS_LOGIN")){
            setLoading(true)
          
          
          if(newUser === false){
            setIsNewUser(false)
          }
        }          
          try {
            if(localStorage.getItem("IS_LOGIN") === "yes") {
              const redemptionResponse = await redemption() 
                
              const response = redemptionResponse.data.data
              if(response.redeemable === false){
                setPaymentStatus('NOT POSSIBLE')
                setPaymentMessage("You are a " + response.user_type)
                setIsSuccess(true)
                setCanRedeem(false)
              }
              else{
                setIsOtpVerified(true)
                if(response.user_type !== "NEW USER"){
                  setIsNewUser(false)
                  setNewUser(false)
                  setMembershipID(response.membership_id)
                }

                if(response.redemption_options.POINTS === true){
                  setRedeemable(true)
                }
                const factor = response.conversion
                const bonusFactor = response.bonus
                setBonusPoint([bonusFactor.Wallet, bonusFactor.Bank, bonusFactor.Points, bonusFactor.PtoR])
                setConversions([factor.Wallet, factor.Bank, factor.Points, factor.PtoR])
              }

            }
            else {
            const fetchResponse = await getTokenPair(phoneNo, arg)
            const status = fetchResponse.status
            if(status === 200){
                const headers = fetchResponse.headers
                localStorage.setItem('x-access-token', 'Token ' + headers['x-access-token'])
                localStorage.setItem('x-refresh-token', 'Token ' + headers['x-refresh-token'])

                const redemptionResponse = await redemption() 
                
                const response = redemptionResponse.data.data
                if(response.redeemable === false){
                  setPaymentStatus('NOT POSSIBLE')
                  setPaymentMessage("You are a " + response.user_type)
                  setIsSuccess(true)
                  setCanRedeem(false)
                }
                else{
                  setIsOtpVerified(true)
                  if(response.user_type !== "NEW USER"){
                    setIsNewUser(false)
                    setNewUser(false)
                    setMembershipID(response.membership_id)
                  }

                  if(response.redemption_options.POINTS === true){
                    setRedeemable(true)
                  }
                  const factor = response.conversion
                  const bonusFactor = response.bonus
                  setBonusPoint([bonusFactor.Wallet, bonusFactor.Bank, bonusFactor.Points, bonusFactor.PtoR])
                  setConversions([factor.Wallet, factor.Bank, factor.Points, factor.PtoR])
                }

            }
            else{
              const errMessageOTP = fetchResponse.response.data;
                // setOtpMessage('Invalid OTP')
                setOtpMessage(errMessageOTP.message.otp)
            }
          }
          } catch (e) {
            setIsVerified(false)
            setMsgPh('Something went wrong')
          } 
          setLoading(false)
        }
    };

    const handleToUpdateAddDetails = (arg: any) => {
      setLoading(true)
        if(arg === 'GoBack'){
            resetAll(true)
        }
        else{
          axios
            .post(
              `${HOST}${API}register-user/`, 
              {
                phone_number: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo,
                name: arg.name,
                profession: arg.profession, 
                pincode: arg.pincode,
                user: userType,
                alternate_mobile_no: arg.alternatePhone
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem('x-access-token')       
                }
              }
            )
            .then((res: any) => {
                if(res.data.data.data.resultCode === 0){
                  setMembershipID(res.data.data.data.membershipId)
                  setIsNewUser(false)
                }
                else{
                  setIsVerified(false)
                  setIsOtpVerified(false)
                  setInvalidCoupon(true)
                  setMsgPh('something went wrong')
                }
                if(res.status === 401 && res.messages.message === refresh_error_msg && count === 0){
                  refresh_access_token(res)
                  handleToUpdateAddDetails(arg)
                  count += 1
                }
                setLoading(false)
              })
            .catch((err: any) => {
                count = 0
                setIsVerified(false)
                setIsOtpVerified(false)
                setMsgPh('Something went wrong')
                setLoading(false)
            });
          }
    }

    const handleToUpdateStatus = (arg: any, message:any, orderId: string, id: string) => {
      // setLoading(true)
      // setOrderID(orderId)      
      //   setPaymentMessage(message)
      //   setPaymentStatus(arg)
      //   if(arg === "FAILURE"){
      //   }
      //   setIsSuccess(true)
      //   setLoading(false)
      setTransactionLoading(true)
      setLoading(true)
      setOrderID(orderId)
      setRazorID(id)
      if(arg !== 'RESPONSE_MESSAGE' && arg !== 'AMOUNTINVALID' && arg !== 'BLOCKUSER' && arg !== 'MEMBERINVALID') {
      axios //to get list of transactions
        .get(
          `${HOST}${API}transaction-details/${userType}/${localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo}/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              setTransactions(res.data)
              setTransactionLoading(false)
            }
          })
        .catch((err: any) => {
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
          setTransactionLoading(false)
        });
      }
        setPaymentMessage(message)
        setPaymentStatus(arg)
        if(arg === "FAILURE"){
        }
        setIsSuccess(true)
        setLoading(false)
    }

    const handleToGetPreviousBankDetails = async() => {
      setLoading(true)
      // if(arg !== 'RESPONSE_MESSAGE' && arg !== 'AMOUNTINVALID' && arg !== 'BLOCKUSER' && arg !== 'MEMBERINVALID') {
      axios //to get list of transactions
        .get(
          `${HOST}${API}banking-details/${userType}/${localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo}/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              setPreviousBankDetails(res.data);
              if(res.data.length >0) {
                setPreviousBankDetailsFlag(true);
              }
              setLoading(false)
            }
          })
        .catch((err: any) => {
          setLoading(false)
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
        });
      // }
    }

    const previouslyAddedBankTransaction = (arg:any, type: any) => {
      setPreviousBankUUID([arg, type]);
      setBankDetailsSet(true);
    }

    const removePreiouslyAddedBanks = async(arg:any) => {
      setLoading(true)
      return axios
          .delete(
            `${HOST}${API}banking-details/`, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token')
              },
              params: {
                user_type: userType,
                bank_uuid: arg
              },
            },
          )
          .then((res: any) => {
            setLoading(false)
            handleToGetPreviousBankDetails();
            return res;
          })
          .catch((err: any) => {
            setLoading(false)
            return err;
          });
    }

    const handleToProceedPayment = async(arg: any, amount:any, type:any, bonusAmount:any) => {
      const path = window.location.pathname;
      const pathParams = path.split('/');
      console.log("kjchesjcwe", arg);

    }

    const handleToUpdateBankDetails = (arg: any) => {
        setLoading(true)
        if(arg === 'GoBack'){
            setIsProceeded(false)
        }
        else{ //api to send bank details locally
            
            setAccNo(arg.accNo)
            setIfsc(arg.ifsc)
            axios
            .post(
              `${HOST}${API}banking-details/`, 
              {
                phone_number: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo, 
                account_number: arg.accNo,
                ifsc_code: arg.ifsc,
                bank_name: arg.bankName === 'Others' ? arg.otherBankName : arg.bankName,
                user_type: userType 
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem('x-access-token')       
                }
              }
            )
            .then((res: any) => {
              if(res.data.message === 'Maximum accounts added' || res.data.message === 'IFSC Code invalid' || res.data.message === 'Record with same account number exists'){
                setBankMsg(res.data.message)
              }
              else{
                setBankDetailsSet(true)
              }
              setLoading(false)
              })
            .catch((err: any) => {
              if(err.status === 401 && err.messages.message === refresh_error_msg && count === 0){
                refresh_access_token(err)
                handleToUpdateAddDetails(arg)
                count += 1
              }
              else{
                count = 0
                resetAll(true)
                setMsgPh('something went wrong')
              }
              setLoading(false)
            });    
        } 
        // setLoading(false)
    }

    const handleToUpdateSuccess = (arg: any) => {
      if(arg === 'GoBack'){
        resetAll(false)
    }
    let myVar:any;
    if(paymentType === "bank") {
      const timeout = async (i:any) =>{
        // setLoading(true)
        myVar = await new Promise((resolve)=> setTimeout(function(){ 
          // if(i === 6) {
          //   // setPaymentStatus("FAILURE")
          //   clearTimeout(myVar);
          //   return;
          // }
          // else 
          if(localStorage.getItem("tran_status") === "FAILURE") {
            clearTimeout(myVar);
            return;
          }
          else if(localStorage.getItem("tran_status") === "SUCCESS") {
            clearTimeout(myVar);
            return;
          }
          axios
          .post(
            `${HOST}${API}get-transaction-status/`, 
            {
              order_id: orderID,
              payment_type: paymentType,
              userType: userType,
              razor_transaction_id: razorID
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token')       
              }
            }
          )
          .then((res: any) => {
              let status = res.data.response.status === "processed" || res.data.response.status === "SUCCESS" ? "SUCCESS" : 
              res.data.response.status === "queued" || res.data.response.status === "pending" || res.data.response.status === "processing" || res.data.response.status === "APPROVAL_PENDING" || res.data.response.status === "PENDING" || res.data.response.status === "QUEUED" || res.data.response.status === "RECEIVED" ? "PENDING" :
              "FAILURE";
              let statusMessage = res.data.response.statusMessage
              setFailUnbind(status);
              if(status !== "PENDING"){
                localStorage.setItem("tran_status", status)
                setPaymentStatus(status)
                setPaymentMessage(statusMessage)
                setConfirmedPayStatus(true)
              }
            })
          .catch((err: any) => {
          });
          if(i === 3) {
            clearTimeout(myVar);
            return;
          }
          resolve(i);
        }, 10000*i));
          // setLoading(false)
      }
      if(arg === "PENDING"){
        if(countCheck === true) {
          for(let i=1; i<=3; i++){
            timeout(i)
          }
        }
        setCount(false);
      }
      if(failUnbind === "SUCCESS"){
        return;
      }
      if(failUnbind === "FAILURE"){
        return;
      }
    }
    else {
    const timeout = async (i:any) =>{
      // setLoading(true)
      myVar = await new Promise((resolve)=> setTimeout(function(){ 
        // if(i === 6) {
        //   // setPaymentStatus("FAILURE")
        //   clearTimeout(myVar);
        //   return;
        // }
        // else 
        if(localStorage.getItem("tran_status") === "FAILURE") {
          clearTimeout(myVar);
          return;
        }
        else if(localStorage.getItem("tran_status") === "SUCCESS") {
          clearTimeout(myVar);
          return;
        }
        axios
        .post(
          `${HOST}${API}get-transaction-status/`, 
          {
            order_id: orderID,
            payment_type: paymentType,
            userType: userType
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            let status = res.data.response.status
            let statusMessage = res.data.response.statusMessage
            setFailUnbind(status);
            if(status !== "PENDING"){
              localStorage.setItem("tran_status", status)
              setPaymentStatus(status)
              setPaymentMessage(statusMessage)
              setConfirmedPayStatus(true)
            }
          })
        .catch((err: any) => {
        });
        if(i === 3) {
          clearTimeout(myVar);
          return;
        }
        resolve(i);
      }, 10000*i));
        // setLoading(false)
    }
    if(arg === "PENDING"){
      if(countCheck === true) {
        for(let i=1; i<=3; i++){
          timeout(i)
        }
      }
      setCount(false);
    }
    if(failUnbind === "SUCCESS"){
      return;
    }
    if(failUnbind === "FAILURE"){
      return;
    }
  }
}

    const handleLogout = () => {
      setIsVerified(true)
      window.location.reload();
      localStorage.clear();
    }
      const { questionType } = props;
        return (
          localStorage.getItem("error_throw") === "yes" ?
            <ErrorMessage />
            :
            <div className='home popup_logout'>
                {
                    loading &&
                    <CircularProgress />
                }

                {
                    !loading && loadingRedeem &&
                    <CircularProgress />
                }

                {localStorage.getItem("IS_LOGIN") === "yes" &&
                <div className="logout_btn_paytm button">
                <button className="logout_btn" onClick={handleLogout}><PowerSettingsNewIcon /> Logout</button>
              </div>
                }

                {
                  couponValid && localStorage.getItem("IS_LOGIN") === "yes" &&
                  <VerifyNumber msgPh={msgPh} scan={codeScanStatus} codeScanStatusCode={codeScanStatusCode} handleToUpdateVerified={handleToUpdateNumber} />
                }
                { 
                    !isVerified && !loading && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'RESPONSE_MESSAGE' &&
                    !localStorage.getItem("IS_LOGIN") &&
                    <VerifyNumber msgPh={msgPh} scan={codeScanStatus} codeScanStatusCode={codeScanStatusCode} handleToUpdateVerified={handleToUpdateNumber} />
                }

                {
                    !isOtpVerified && isVerified && !loading && canRedeem && !localStorage.getItem("IS_LOGIN") &&
                    <VerifyOtp handleToUpdateOtp={handleToUpdateOTP} msg={otpMessage} />
                }

                {
                    isOtpVerified && isNewUser && !loading && !loadingRedeem && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'RESPONSE_MESSAGE' && paymentStatus !== 'NOT POSSIBLE' &&
                    <CustomerDetails division={userType} handleToUpdateAdded={handleToUpdateAddDetails}/>
                }
                
                {
                    !isNewUser && !isProceeded && paymentStatus !== 'NOT POSSIBLE' && isOtpVerified && !couponValid &&
                    <TransactionDetails conversions={conversions} redeemPoints={redeemable} amount={amount} 
                    userType={userType} handleToProceed={handleToProceedPayment} bonusPoint={bonusPoint} />
                }

                {
                    isProceeded && !isSuccess && paymentType==='paytm' && !loading && !couponValid &&
                    <Payouts type="wallet" phoneNumber={phoneNo} amount={amount} coupon={couponCode} user={userType} 
                    membershipID={membershipID} handleToUpdateStatus={handleToUpdateStatus} prevBankUUID={prevBankUUID} 
                    questionType={questionType} bonusAmount={bonusAmount} />
                }

                {
                    isProceeded && !isSuccess && paymentType==='bank' && !loading && !couponValid && !bankDetailsSet && !previousBankDetailsFlag &&
                    <BankDetails bankMsg={bankMsg} handleToUpdatePayment={handleToUpdateBankDetails}/> 
                }

                {
                    isProceeded && !isSuccess && paymentType==='bank' && !loading && !couponValid && !bankDetailsSet && previousBankDetailsFlag &&
                    <PreviousBankDetails 
                    handleToProceed={handleToProceedPayment} previousBankDetails={previousBankDetails} amount={amount} 
                    prevBankType={prevBankType} previouslyAddedBankTransaction={previouslyAddedBankTransaction} 
                    removePreiouslyAddedBanks={removePreiouslyAddedBanks} bonusAmount={bonusAmount} />
                }

                {
                    bankDetailsSet && !isSuccess && paymentType==='bank' && !loading && !couponValid &&
                    <Payouts type="bank" phoneNumber={phoneNo} amount={amount} coupon={couponCode} user={userType} 
                    membershipID={membershipID} accNo={accNo} ifsc={ifsc} handleToUpdateStatus={handleToUpdateStatus} 
                    prevBankUUID={prevBankUUID} questionType={questionType} bonusAmount={bonusAmount} />
                }

                {
                    isProceeded && !isSuccess && paymentType==='points' && !loading && !couponValid &&
                    <Payouts type="points" user={userType} membershipID={membershipID} coupon={couponCode} phoneNumber={phoneNo} 
                    amount={amount}  handleToUpdateStatus={handleToUpdateStatus} prevBankUUID={prevBankUUID} questionType={questionType}
                    bonusAmount={bonusAmount} />
                }

                {
                    isSuccess && !confirmedPayStatus && !loading && !couponValid &&
                    <Success paymentMessage={paymentMessage} transactions={transactions} paymentStatus={paymentStatus} 
                    handleToUpdateTransactionOK={handleToUpdateSuccess} transactionLoading={transactionLoading} />
                }

                {
                    isSuccess && confirmedPayStatus && !loading && !couponValid &&
                    <Success paymentMessage={paymentMessage} transactions={transactions} paymentStatus={paymentStatus} 
                    handleToUpdateTransactionOK={handleToUpdateSuccess} transactionLoading={transactionLoading} />
                }

                <Footer />

            </div>             
        )
    }

export default MainContractor